import { Injectable } from '@angular/core';
import { DatabaseGwService } from '../database-gw.service';

@Injectable({
  providedIn: 'root'
})
export class AdjustmentsDetailService extends DatabaseGwService{

  URL_PATH: string = "/inv-adj-details";
}
